<template>
  <b-card class="mb-2">

    <div class="d-flex align-items-center mb-2">
      <div class="stat-header-icon bg-light-success">
        <feather-icon
          icon="DollarSignIcon"
          size="20"
        />
      </div>

      <div class="ml-1">
        <h4 class="mb-25">
          Resumen económico
        </h4>

        <small class="text-muted">
          Órdenes y recaudación
        </small>
      </div>
    </div>

    <!-- ÓRDENES -->
    <b-row>

      <b-col
        cols="12"
        sm="6"
        md="3"
      >
        <div class="stat-item">
          <div class="stat-icon bg-light-primary">
            <feather-icon
              icon="ShoppingCartIcon"
              size="18"
            />
          </div>

          <div>
            <small>Total órdenes</small>
            <h3 class="mb-0">
              {{ formatNumber(stats.total_ordenes) }}
            </h3>
          </div>
        </div>
      </b-col>

      <b-col
        cols="12"
        sm="6"
        md="3"
      >
        <div class="stat-item">
          <div class="stat-icon bg-light-success">
            <feather-icon
              icon="CheckCircleIcon"
              size="18"
            />
          </div>

          <div>
            <small>Activas</small>
            <h3 class="text-success mb-0">
              {{ formatNumber(stats.activas) }}
            </h3>
          </div>
        </div>
      </b-col>

      <b-col
        cols="12"
        sm="6"
        md="3"
      >
        <div class="stat-item">
          <div class="stat-icon bg-light-danger">
            <feather-icon
              icon="XCircleIcon"
              size="18"
            />
          </div>

          <div>
            <small>Canceladas</small>
            <h3 class="text-danger mb-0">
              {{ formatNumber(stats.canceladas) }}
            </h3>
          </div>
        </div>
      </b-col>

      <b-col
        cols="12"
        sm="6"
        md="3"
      >
        <div class="stat-item">
          <div class="stat-icon bg-light-info">
            <feather-icon
              icon="CheckSquareIcon"
              size="18"
            />
          </div>

          <div>
            <small>Autorizadas</small>
            <h3 class="text-info mb-0">
              {{ formatNumber(stats.autorizadas) }}
            </h3>
          </div>
        </div>
      </b-col>

    </b-row>

    <hr>

    <!-- RECAUDACIÓN -->
    <b-row>

      <b-col
        cols="12"
        md="6"
      >
        <div class="money-stat">
          <div class="stat-icon bg-light-success">
            <feather-icon
              icon="DollarSignIcon"
              size="22"
            />
          </div>

          <div>
            <small>Recaudación</small>

            <h2 class="text-success mb-0">
              {{ formatCurrency(stats.recaudacion) }}
            </h2>
          </div>
        </div>
      </b-col>

      <b-col
        cols="12"
        md="6"
      >
        <div class="money-stat">
          <div class="stat-icon bg-light-primary">
            <feather-icon
              icon="TargetIcon"
              size="22"
            />
          </div>

          <div>
            <small>Meta de recaudación</small>

            <h2 class="text-primary mb-0">
              {{ formatCurrency(stats.meta_recaudacion) }}
            </h2>
          </div>
        </div>
      </b-col>

    </b-row>

  </b-card>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
} from 'bootstrap-vue'

import { computed } from '@vue/composition-api'
import { formatNumber, formatCurrency } from '@core/utils/utils'

export default {
  components: {
    BCard,
    BRow,
    BCol,
  },
  props: {
    datos: {
      type: Object,
      required: true,
    },
    loader: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const stats = computed(() => props.datos)
    return {
      stats,
      formatNumber,
      formatCurrency,
    }
  },
}
</script>
